ApiError = require 'app/scripts/network/api-error'
Auth = require 'app/scripts/db/auth'
Payloads = require 'app/scripts/network/payloads'
log = require 'app/scripts/debug/log'
Promise = require 'bluebird'
$ = require 'jquery'
{ ErrorViews } = require 'app/common/data/error-views'
{ LDFlags, Tabs } = require 'app/src/components/EnterpriseDashboard'
{ featureFlagClient } = require '@trello/feature-flag-client'

{ enterpriseRoutesViewLoader } = require './enterprise-routes-view-loader'

module.exports =
  routes: [
    ['e/:name/admin', 'enterpriseAdminDashboardView']
    ['e/:name/admin/*tab', 'enterpriseDashTab']
  ]

  displayEnterprisePage: (settings) ->
    { enterpriseName, viewClass, tab } = settings

    log('controller', ['enterprise'])

    Promise.using @getSpinner(), =>
      # Dependency required at call site to avoid import cycles, do not lift to top of module
      Enterprise = require 'app/scripts/models/enterprise'
      # Dependency required at call site to avoid import cycles, do not lift to top of module
      ModelCache = require 'app/scripts/db/model-cache'

      enterprise = ModelCache.findOne('Enterprise', 'name', enterpriseName)
      enterpriseIdOrName = enterprise?.id || enterpriseName

      Enterprise.load enterpriseIdOrName, Payloads.enterprise, ModelCache
      .then (enterprise) =>
        if tab? && (tab.startsWith(Tabs.SSO_SETTINGS) && !featureFlagClient.get(LDFlags.SSO_SELF_SERVE, false))
          @displayErrorPage()
          return

        # We need to check this here rather than at the beginning of the method
        # cause sometimes Auth.me() doesn't yet exist there, but it always
        # exists here.
        unless Auth.me().get('confirmed')
          @displayErrorPage
            errorType: ErrorViews.UNCONFIRMED_ENTERPRISE_NOT_FOUND
            email: Auth.me().get('email')
          return

        if !enterprise.isRealEnterprise()
          @displayErrorPage()
          return

        @clearPreviousView()
        @setViewType(enterprise)
        @showHeader({
          headerBrandingColor: enterprise.get('prefs')?.brandingColor
          headerBrandingLogo: enterprise.getHeaderLogo()
          headerBrandingName: enterprise.get('displayName')
        })
        $('#trello-root').addClass('body-tabbed-page')

        options = { modelCache: ModelCache, initialTab: tab }
        enterpriseView = @topLevelView(viewClass, enterprise, options)
        $('#content').html(enterpriseView.render().el)

        title = enterprise.get('displayName')

        @setLocation
          title: title
          location: settings.getLocation.call(@, enterprise.get('name'), tab)

        return
      .catch ApiError, =>
        @displayErrorPage()
        return

  enterpriseAdminDashboardView: (enterpriseName) ->
    enterpriseRoutesViewLoader()
    .then (EnterpriseAdminDashboardView) =>
      @displayEnterprisePage
        enterpriseName: enterpriseName
        viewClass: EnterpriseAdminDashboardView
        getLocation: @getEnterpriseAdminDashboardUrl
      .done()

  enterpriseDashTab: (enterpriseName, tab) ->
    allowedTabs = Object.values(Tabs)
    if tab not in allowedTabs
      @displayErrorPage()
      return

    enterpriseRoutesViewLoader()
    .then (EnterpriseAdminDashboardView) =>
      @displayEnterprisePage
        enterpriseName: enterpriseName
        viewClass: EnterpriseAdminDashboardView
        getLocation: @getEnterpriseAdminDashboardUrl
        tab: tab
      .done()
